import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { Box } from '@mui/material';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { SplunkTelemetryModel } from '@/lib/models/telemetry/splunk-telemetry.model';

interface Props {
  telemetry: SplunkTelemetryModel;
  formHandle: FormHandle<TelemetryModel>;
  isNew: boolean;
}

const SplunkTelemetry: FC<Props> = ({ formHandle, isNew }) => {
  return (
    <Box>
      <InputControl name="config.hecUrl" label="HEC URL" formHandle={formHandle} />

      <InputControl name="config.source" label="Source Identifier" formHandle={formHandle} />

      <InputControl
        name="config.hecToken"
        label="HEC Token"
        formHandle={formHandle}
        updateOnly={!isNew}
        required={isNew}
      />

      <InputControl
        name="config.indexes.userEvents"
        label="User Event Index"
        formHandle={formHandle}
      />

      <InputControl
        name="config.indexes.auditEvents"
        label="Audit Event Index"
        formHandle={formHandle}
      />

      <InputControl
        name="config.allowSelfSignedCertificates"
        label="Allow self-signed certificates"
        type="switch"
        formHandle={formHandle}
        inline
      />
    </Box>
  );
};

export default SplunkTelemetry;
